import { sstPreviewUrl } from "./sstPreviewUrl";

export const URL_TRIVIA = sstPreviewUrl(
  process.env.NEXT_PUBLIC_TRIVIA_ORIGIN,
  "trivia",
);
export const URL_TRIVIA_IMAGE =
  "https://images.hallow.app/games/trivia/0_l.webp";
